enum ANSTextEnum {
	ALL = 'all',
}

export {ANSTextEnum};
